// dummy for future dynamic color loading, currently just returns hardcoded colors
export const loadColors = async () => {
  return {
    '--primary-1-50': '#FDEFE6',
    '--primary-1-100': '#FBDFCE',
    '--primary-1-200': '#F7BF9D',
    '--primary-1-300': '#F3A06C',
    '--primary-1-400': '#EF803B',
    '--primary-1-500': '#EB600A',
    '--primary-1-600': '#BC4D08',
    '--primary-1-700': '#8D3A06',
    '--primary-1-800': '#5E2604',
    '--primary-1-900': '#2F1302',
    '--primary-2-50': '#FFF6E5',
    '--primary-2-100': '#FFEECC',
    '--primary-2-200': '#FFDC99',
    '--primary-2-300': '#FFCB66',
    '--primary-2-400': '#FFB933',
    '--primary-2-500': '#FFA800',
    '--primary-2-600': '#CC8600',
    '--primary-2-700': '#996500',
    '--primary-2-800': '#664300',
    '--primary-2-900': '#332200',
    '--action': '#EB600A',
    '--action-hover': '#BC4D08',
    '--action-soft': '#FBDFCE',
    '--action-gradient-start': '#EB600A',
    '--action-gradient-end': '#FFA800',
    '--warning': '#D5B846',
    '--warning-hover': '#AB9334',
    '--warning-soft': '#FFF8DD',
    '--success': '#3A9F72',
    '--success-hover': '#2B7755',
    '--success-soft': '#DAF4E8',
    '--error': '#FF3860',
    '--error-hover': '#CF2D4D',
    '--error-soft': '#FFD7DF',
    '--on-action': '#FFFFFF'
  }
}
